var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"youtube-video-player mx-auto"},[_c('iframe',{attrs:{"src":_vm.url,"width":"560","height":"315","frameborder":"0","allowfullscreen":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }